(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-roles-select-view', [
      'checklist-model',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.modules.authentication.k-roles'
    ])
    .component('kUserRolesSelectView', {
      bindings: {
        disabledRoles: '<?', // array of K_ROLE, or object map {K_ROLE : bool}
        hiddenRoles: '<?', // array of K_ROLE, or object map {K_ROLE : bool}
        selectedRoles: '=' // array containing selected roles
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-roles-select-view.pug')()
    });

  controller.$inject = ['$scope', 'K_ROLES'];
  function controller($scope, K_ROLES) {
    const vm = this;

    vm.roles = K_ROLES;
    vm.rows = [];

    vm.$onInit = init;

    // ------------------------------------------------------------------------

    function init() {
      updateDisabledRoles();
      updateVisibleRoles();

      $scope.$watch('vm.disabledRoles', updateDisabledRoles);
      $scope.$watch('vm.hiddenRoles', updateVisibleRoles);
    }

    function rolesMap(roles) {
      var map = {};
      if (angular.isArray(roles)) {
        angular.forEach(roles, (K_ROLE) => {
          map[K_ROLE] = true;
        });
      } else if (angular.isObject(roles)) {
        map = roles;
      }
      return map;
    }

    function updateDisabledRoles() {
      vm.disabledRolesMap = rolesMap(vm.disabledRoles);
    }

    function updateVisibleRoles() {
      var hiddenRolesMap = rolesMap(vm.hiddenRoles);
      var numVisibleRoles = 0;
      vm.rows = [];

      angular.forEach(K_ROLES, (K_ROLE) => {
        if (!hiddenRolesMap[K_ROLE]) {
          if (numVisibleRoles % 3 === 0) {
            vm.rows.push([]);
          }
          vm.rows[vm.rows.length - 1].push(K_ROLE);
          numVisibleRoles++;
        }
      });
    }
  }
})();
